import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiMapMarkerOutline } from '@mdi/js';
import { formatDate } from 'cd-eft/utils/formatDate';
import { ImagesComponent } from '../Project/Project';
import { UserDefinedImages } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import stores from 'cd-eft/models/Stores';
import './DesignElementTypeData.scss';

const libraryStore = stores.AppStore.projectsLibraryStore;

export const imageName = {
  0: 'Plan view',
  1: 'Plan view',
  2: 'Location view',
  3: 'Other view',
  // 4: 'Three cross section view',
  // 5: 'Single cross section view',
};

export const DesignElementTypeData = observer(({ projectId, type }) => {
  const designElementType = {
    1: 'surface',
    2: 'surface',
    5: 'alignment',
    11: 'pit',
    12: 'pit',
    13: 'pit',
    14: 'pad',
    15: 'land-leveling',
    16: 'alignment',
    17: 'alignment',
  };

  return (
    <>
      {type.designElements.map((item) => {
        return (
          <div key={`designElement-${item.designElementId || item.surveyId}`}>
            <h3>{item.designElementName} </h3>
            <div className="cross-sections">
              <strong> Id: </strong>
              {item.designElementId}
            </div>
            <div className="cross-sections">
              <strong> Design Type: </strong>
              {type.designElementType}
            </div>
            <div className="cross-sections">
              <strong> Date Created: </strong>
              {formatDate(item.createdDate)}
            </div>

            {libraryStore.designElementsImageDic &&
              libraryStore.designElementsImageDic[item.designElementId] &&
              libraryStore.designElementsImageDic[item.designElementId].some(
                (el: UserDefinedImages) => el.imageTypeId != 5
              ) && (
                <div className="images-section">
                  <ImagesComponent
                    section="Images"
                    imagesDictionary={libraryStore.designElementsImageDic[item.designElementId]
                      .filter((el: UserDefinedImages) => el.imageTypeId != 5)
                      .map((el: UserDefinedImages) => {
                        return { ...el, imageName: imageName[el.imageTypeId!] };
                      })}
                  />
                </div>
              )}

            {libraryStore.designElementsImageDic &&
              libraryStore.designElementsImageDic[item.designElementId] &&
              libraryStore.designElementsImageDic[item.designElementId].some(
                (el: UserDefinedImages) => el.imageTypeId == 5
              ) && (
                <div className="images-section">
                  <ImagesComponent
                    section="Single Cross Section"
                    imagesDictionary={libraryStore.designElementsImageDic[item.designElementId].filter(
                      (el: UserDefinedImages) => el.imageTypeId == 5
                    )}
                  />
                </div>
              )}
            <hr />
          </div>
        );
      })}
      <div className="text-right">
        <Link
          className="quick-link-button bg-white my-2 usa-button usa-button--outline"
          to={`/design/${projectId}/${designElementType[type.designElementTypeId]}`}
        >
          <Icon path={mdiMapMarkerOutline} title="SET Icon" size={1} color="#005ea2" />
          Continue to {type.designElementType} Workflow
        </Link>
      </div>
    </>
  );
});
